import type { LucideIcon } from 'lucide-react'
import { ShieldCheck } from 'lucide-react'
import { cn } from '../lib/utils'

interface EmptyStateProps {
  icon?: LucideIcon
  title: string
  message?: string
  className?: string
  action?: {
    label: string
    onClick: () => void
  }
}

export function EmptyState({
  icon: Icon = ShieldCheck,
  title,
  message,
  className,
  action,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center py-12 px-4 text-center',
        className,
      )}
      role="status"
      aria-live="polite"
    >
      <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center mb-4">
        <Icon className="w-8 h-8 text-gray-400" aria-hidden="true" />
      </div>
      <h3 className="text-lg font-semibold text-navy mb-1">{title}</h3>
      {message && <p className="text-sm text-gray-500 max-w-xs">{message}</p>}
      {action && (
        <button
          type="button"
          onClick={action.onClick}
          className="mt-4 tap-min px-4 py-2 bg-brass text-white rounded-lg text-sm font-medium hover:bg-brass-dark transition-colors focus:outline-none focus:ring-2 focus:ring-brass focus:ring-offset-2"
        >
          {action.label}
        </button>
      )}
    </div>
  )
}
